var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from 'react';
import { Badge } from '../../ui/badge';
import { cn } from '../../../lib/utils';
var InputBadge = React.forwardRef(function (_a, ref) {
    var className = _a.className, _b = _a.type, type = _b === void 0 ? 'text' : _b, onChangeTags = _a.onChangeTags, value = _a.value, validateTag = _a.validateTag, props = __rest(_a, ["className", "type", "onChangeTags", "value", "validateTag"]);
    // Use provided value or fallback to an empty array
    var _c = React.useState(value || []), tags = _c[0], setTags = _c[1];
    var _d = React.useState(''), inputValue = _d[0], setInputValue = _d[1];
    // If a controlled `value` is passed, update local state accordingly
    React.useEffect(function () {
        if (value) {
            setTags(value);
        }
    }, [value]);
    var addTag = function () {
        if (inputValue.trim() !== '') {
            var newTag = inputValue.trim().replace(/,$/, ''); // remove trailing comma if any
            // Validate if function provided
            if (validateTag && !validateTag(newTag)) {
                return; // do not add invalid tag
            }
            var newTags = __spreadArray(__spreadArray([], tags, true), [newTag], false);
            setTags(newTags);
            setInputValue('');
            if (onChangeTags) {
                onChangeTags(newTags);
            }
        }
    };
    var handleKeyDown = function (e) {
        if (e.key === 'Enter' || e.key === ',') {
            e.preventDefault();
            addTag();
        }
    };
    // On blur, if there is text in the input, transform it into a badge.
    // eslint-disable-next-line no-unused-vars, @typescript-eslint/no-unused-vars
    var handleBlur = function (e) {
        if (inputValue.trim() !== '') {
            addTag();
        }
    };
    // Remove tag at index
    var handleRemoveTag = function (index) {
        var newTags = tags.filter(function (_, i) { return i !== index; });
        setTags(newTags);
        if (onChangeTags) {
            onChangeTags(newTags);
        }
    };
    return (_jsxs("div", { className: cn('flex h-11 w-full flex-wrap items-center gap-2 rounded-lg border border-input bg-background px-3 py-2 text-base ring-offset-background focus-within:outline-none focus-within:ring-2 focus-within:ring-ring focus-within:ring-offset-2 focus-within:ring-primary disabled:cursor-not-allowed disabled:opacity-50 md:text-sm'), children: [tags.map(function (tag, index) { return (_jsxs(Badge, { className: 'mr-1 flex items-center', children: [_jsx("span", { className: 'text-sm', children: tag }), _jsx("button", { type: 'button', className: 'ml-2 rounded-full focus:outline-none', onClick: function () { return handleRemoveTag(index); }, children: _jsx("span", { className: 'text-sm', children: "\u00D7" }) })] }, index)); }), _jsx("input", __assign({ ref: ref, type: type, value: inputValue, onChange: function (e) { return setInputValue(e.target.value); }, onKeyDown: handleKeyDown, onBlur: handleBlur, placeholder: 'Type and press Enter or comma...', className: cn('flex-1 bg-transparent p-0 focus:outline-none placeholder:text-input-color', className) }, props))] }));
});
InputBadge.displayName = 'InputBadge';
export { InputBadge };
